module.exports = __webpack_public_path__ + "img/brightpoint_icon_active_2.22a9132c.png";